var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerIconGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "18px",
    viewBox: "0 0 36 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "xxxhdpi/icon/container") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profiles-list---1440px",
    transform: "translate(-131.000000, -247.000000)",
    stroke: "#DDDDDD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-profile-drop",
    transform: "translate(88.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(44.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/container"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,3.0515625 L5,14",
    id: "Line-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1.0703125 L2,16",
    id: "Line-3-Copy-7",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,1.0703125 L32,16",
    id: "Line-3-Copy-8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,3.0515625 L9,14",
    id: "Line-3-Copy",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,3.0515625 L13,14",
    id: "Line-3-Copy-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,3.0515625 L17,14",
    id: "Line-3-Copy-3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,3.0515625 L21,14",
    id: "Line-3-Copy-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,3.0515625 L29,14",
    id: "Line-3-Copy-5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,3.0515625 L25,14",
    id: "Line-3-Copy-6",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 0.5,
    width: 32,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.55271368e-15,17 L34,17",
    id: "Line-2",
    strokeLinecap: "square"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerIconGrey);
export default __webpack_public_path__ + "static/media/container_icon_grey.a8a4d743673f6ffe5c296f34c86d085e.svg";
export { ForwardRef as ReactComponent };